<template>
  <div class="edit-payment">
    <div class="form-wrapper">
      <el-form
        :model="formData"
        label-position="left"
        :inline="false"
        label-width="100px"
      >
        <el-form-item label="项目部">
          <el-input
            :value="formData.deptName ? formData.deptName : ''"
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input
            :value="formData.projectName ? formData.projectName : ''"
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="付款申请日期">
          <el-input
            :value="formData.payApplyDate ? formData.payApplyDate : ''"
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="付款明细日期">
          <el-input
            :value="formData.payDetailDate ? formData.payDetailDate : ''"
            readonly
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-wrapper">
      <el-table :data="tableList" border width="100%" height="450">
        <el-table-column label="序号" type="index" fixed></el-table-column>
            <el-table-column label="收款单位名称" prop="vendorName" width="200" fixed></el-table-column>
            <el-table-column label="开户行" prop="bankName" width="200"></el-table-column>
            <el-table-column label="账户" prop="cardNumber" width="200"></el-table-column>
            <el-table-column label="本次审批付款额" width="200">
              <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.payAmount)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="支付方式">
              <el-table-column label="转账支票" width="100">
                <template slot-scope="scope">
                  <div>{{formatMoneyNumber(scope.row.checkAmount)}}</div>
                </template>
              </el-table-column>
              <el-table-column label="网银" width="100">
                <template slot-scope="scope">
                  <div>{{formatMoneyNumber(scope.row.ebankAmount)}}</div>
                </template>
              </el-table-column>
              <el-table-column label="商业承兑(纸质/电子)" width="100">
                <template slot-scope="scope">
                  <div>{{formatMoneyNumber(scope.row.tradeAcceptanceAmount)}}</div>
                </template>
              </el-table-column>
              <el-table-column label="银行承兑(纸质/电子)" width="100">
                <template slot-scope="scope">
                  <div>{{formatMoneyNumber(scope.row.bankAcceptanceAmount)}}</div>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="当前已付款额" width="200">
              <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.alreadyPayAmount)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark" width="200"></el-table-column>
            <el-table-column label="操作" width="200" fixed="right">
              <template slot-scope="scope">
                <div>
                  <el-button type="text" @click="editRow(scope.row)"
                      >编辑</el-button
                    >
                </div>
              </template>
            </el-table-column>
      </el-table>
    </div>
    <div style="text-align: center;margin-top: 16px;margin-bottom:16px;">
      <el-button type="primary" @click.stop="submitData">提交</el-button>
      <el-button type="info" @click.stop="cancelSubmit">取消</el-button>
    </div>
    <el-dialog title="编辑" :visible.sync="dialogVisible" width="600px">
      <el-form :model="dialogData" label-width="160px" label-position="right">
        <el-form-item label="收款单位名称">
          <el-input
            :value="
              dialogData && dialogData.vendorName ? dialogData.vendorName : ''
            "
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="开户行">
          <el-input
            :value="
              dialogData && dialogData.bankName ? dialogData.bankName : ''
            "
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="账户">
          <el-input
            :value="
              dialogData && dialogData.cardNumber ? dialogData.cardNumber : ''
            "
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="本次审批付款额">
          <el-input
            :value="dialogData && dialogData.payAmount ? dialogData.payAmount : ''"
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="转账支票">
          <el-input-number
            v-model="dialogData.checkAmount"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            @change="checkAmountHandler"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="网银">
          <el-input-number
            v-model="dialogData.ebankAmount"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            @change="ebankAmountHandler"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="商业承兑（纸质/电子）">
          <el-input-number
            v-model="dialogData.tradeAcceptanceAmount"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            @change="tradeAcceptanceAmountHandler"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="银行承兑（纸质/电子）">
          <el-input-number
            v-model="dialogData.bankAcceptanceAmount"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            @change="bankAcceptanceAmountHandler"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="当前已付款额">
          <el-input-number
            v-model="dialogData.alreadyPayAmount"
            controls-position="right"
            clearable
            :precision="2"
            placeholder="请输入"
            disabled
          ></el-input-number>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="2"
            v-model="dialogData.remark"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center;">
        <el-button type="primary" @click.stop="confirmDialog">确定</el-button>
        <el-button type="info" @click.stop="cancelDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 付款明细-编辑
 */
import Constants from "@/utils/consts";
import {
  getPaymentDetail,
  editPaymentDetail
} from "../../services/financeService";
import { formatYMDstr } from "../../utils/index";
import { formatMoney } from "./utils";
export default {
  name: "EditPayment",
  data() {
    return {
      id: undefined,
      formData: {
        deptId: undefined, //项目部id
        deptName: undefined,
        projectName: undefined,
        projectId: undefined, //项目id
        payApplyDate: undefined, //付款申请日期
        payDetailDate: undefined //付款明细日期
      },
      tableList: [], // 填的数据
      dialogVisible: false,
      dialogData: {}
    };
  },
  methods: {
    formatMoneyNumber: formatMoney,
    formatYMDstr,
    onActive() {
      let params = this.tabRouteParam || {};
      if (params.id) {
        this.id = params.id;
      }
      if (!this.id) {
        return;
      }
      this.getDetail();
    },
    getDetail() {
      getPaymentDetail({
        id: this.id
      })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.detailData = res.data || {};
            this.formData.deptId = this.detailData.deptId;
            this.formData.deptName = this.detailData.deptName;
            this.formData.projectId = this.detailData.projectId;
            this.formData.projectName = this.detailData.projectName;
            this.formData.payApplyDate = this.detailData.payApplyDate;
            this.formData.payDetailDate = this.detailData.payDetailDate;
            this.tableList = this.detailData.payDetailItemVOList || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    editRow(item) {
      console.log('editRow', item);
      this.editTargetItem = item;
      this.dialogData.vendorName = item.vendorName;
      this.dialogData.partyBId = item.partyBId;
      this.dialogData.bankName = item.bankName;
      this.dialogData.cardNumber = item.cardNumber;
      this.dialogData.payAmount = item.payAmount;
      this.$set(this.dialogData, 'checkAmount', item.checkAmount || 0);
      this.$set(this.dialogData, 'ebankAmount', item.ebankAmount || 0);
      this.$set(this.dialogData, 'tradeAcceptanceAmount', item.tradeAcceptanceAmount || 0);
      this.$set(this.dialogData, 'bankAcceptanceAmount', item.bankAcceptanceAmount || 0);
      this.$set(this.dialogData, 'alreadyPayAmount', item.alreadyPayAmount || 0);
      this.$set(this.dialogData, "remark", item.remark);
      this.dialogVisible = true;
    },
    confirmDialog() {
      this.$set(this.editTargetItem, 'checkAmount', Number(this.dialogData.checkAmount || 0));
      this.$set(this.editTargetItem, 'ebankAmount', Number(this.dialogData.ebankAmount || 0));
      this.$set(this.editTargetItem, 'tradeAcceptanceAmount', Number(this.dialogData.tradeAcceptanceAmount || 0));
      this.$set(this.editTargetItem, 'bankAcceptanceAmount', Number(this.dialogData.bankAcceptanceAmount || 0));
      this.$set(this.editTargetItem, 'alreadyPayAmount', Number(this.dialogData.alreadyPayAmount || 0));
      this.$set(this.editTargetItem, 'remark', this.dialogData.remark);
      this.dialogVisible = false;
      this.dialogData = {};
    },
    cancelDialog() {
      this.dialogVisible = false;
      this.dialogData = {};
    },
    submitData() {
      this.$confirm("确定要提交数据吗？", "提示", {
        confirmButtonText: "确定",
        type: "warning"
      })
        .then(() => {
          let params = {};
          params.id = this.id;
          params.deptId = this.formData.deptId;
          params.deptName = this.formData.deptName;
          params.projectName = this.formData.projectName;
          params.projectId = this.formData.projectId;
          params.payApplyDate = this.formatYMDstr(this.formData.payApplyDate);
          params.payDetailDate = this.formatYMDstr(this.formData.payDetailDate);
          params.payDetailItemDtoList = this.tableList || [];
          editPaymentDetail(params)
            .then(res => {
              if (res.code == Constants.Code_OK) {
                this.$alert("操作成功", "提示");
                this.bus.$emit("tabClose", "editPayment");
                this.bus.$emit("navMenuChange", {
                  routeId: "paymentList"
                });
              } else {
                this.$alert(res.msg, "提示");
              }
            })
            .catch(error => {
              this.$alert(
                error instanceof Error ? error.message : error,
                "提示"
              );
            });
        })
        .catch(() => {});
    },
    cancelSubmit() {
      this.$confirm("确定要取消编辑吗？", "提示", {
        confirmButtonText: "确定",
        type: "warning"
      })
        .then(() => {
          this.bus.$emit("tabClose", "editPayment");
          this.bus.$emit("navMenuChange", {
            routeId: "paymentList"
          });
        })
        .catch(() => {});
    },
    // 自动计算
    bankAcceptanceAmountHandler() {
      this.updateAlreadyPayAmount();
    },
    tradeAcceptanceAmountHandler() {
      this.updateAlreadyPayAmount();
    },
    ebankAmountHandler() {
      this.updateAlreadyPayAmount();
    },
    checkAmountHandler() {
      this.updateAlreadyPayAmount();
    },
    updateAlreadyPayAmount() {
      
      let alreadyPayAmount  = Number(this.dialogData.checkAmount || 0) + Number(this.dialogData.ebankAmount || 0) + Number(this.dialogData.tradeAcceptanceAmount || 0) + Number(this.dialogData.bankAcceptanceAmount || 0);
      // this.dialogData.alreadyPayAmount = alreadyPayAmount;
      this.$set(this.dialogData, "alreadyPayAmount", alreadyPayAmount);
      console.log('--updateAlreadyPayAmount', alreadyPayAmount);
    }
  }
};
</script>

<style lang="scss" scoped>
// @import "./table.scss";

.edit-payment {
  background: white;
  display: flex;
  flex-direction: column;
}


/deep/.el-input-number {
  width: 100%;

  input {
    text-align: left;
  }
}
</style>
